<template>
    <div class="authorityList">
        <el-card class="box-card fl">
            <div slot="header" class="clearfix header">
                <span class="card-header fl">模块菜单</span>
                <el-button class="fr" size="mini" type="success" @click="AddMenuForm()" v-if="authorityAuth.AddMenuForm">新增</el-button>
            </div>
            <!-- theData -->
            <el-aside width="400px" style="padding: 15px;"> 
                <el-tree
                    ref="eventCategoryTree"
                    :data="theData"
                    :props="defaultProps"
                    node-key="id"
                    highlight-current
                    default-expand-all
                    :render-content="renderContent"
                    :expand-on-click-node="false"> 
                </el-tree> 
            </el-aside>
            <!-- 新增一级、二级菜单 -->
            <el-dialog :title="textMenuMap[dialogMenuStatus]" :visible.sync="dialogMenuVisible" :close-on-click-modal="false" @close='emptyDialog'>
                <el-form :label-position="labelPosition" :model="menuForm" label-width="120px" :rules="menuFormRules" ref="menuForm" class="clearfix">
                    <el-form-item v-show="dialogMenuStatus !=='newdata' && menuForm.dLevel !== 0 " label="上一级菜单名称:" prop="menuName" style="width: 48%;margin-right: 15px;" class="fl">
                        <el-input v-model.trim="menuForm.menuName" :disabled="true"></el-input>
                    </el-form-item>
                    <el-form-item label="菜单名称:" prop="menuNameNew" style="width: 48%;margin-right: 15px;" class="fl">
                        <el-input type="text" v-model.trim="menuForm.menuNameNew"></el-input>
                    </el-form-item>
                    <el-form-item label="菜单编码:" prop="menuCode" style="width: 48%;margin-right: 15px;" class="fl">
                        <el-input type="text" v-model.trim="menuForm.menuCode"></el-input>
                    </el-form-item>
                    <el-form-item label="菜单图标:" prop="menuIcon" style="width: 48%;margin-right: 15px;" class="fl">
                        <el-input type="text" v-model.trim="menuForm.menuIcon" placeholder="请输入icon名称"></el-input>
                    </el-form-item>
                    <el-form-item label="菜单url:" prop="menuUrl" style="width: 48%;margin-right: 15px;" class="fl">
                        <el-input  type="text" v-model.trim="menuForm.menuUrl" placeholder="请输入有效的平台路径"></el-input>
                    </el-form-item>
                    <el-form-item label="是否为根节点:" prop="isRoot" style="width: 48%;margin-right: 15px;" class="fl">
                        <el-select v-model.trim="menuForm.isRoot" style="width: 100%;">
                            <el-option :label="item.product_type" :value="item.categorya_id" v-for="(item,index) in contractLists" :key="index"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="备注:" prop="memo" style="width: 100%;" class="fl">
                        <el-input type="textarea" v-model.trim="menuForm.memo" placeholder="请输入描述信息"></el-input>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button v-if="dialogMenuStatus =='newdata'" type="success" @click="FirstLevelMenu('menuForm')">添加</el-button>
                    <el-button v-else-if="dialogMenuStatus =='update'" type="success" @click="updateMenu('menuForm')">添加</el-button>
                    <el-button type="warning" @click.native="dialogMenuVisible=false">取消</el-button>
                </div>
            </el-dialog>
            <!-- 修改菜单 -->
            <el-dialog title="修改菜单" :visible.sync="dialogMenuVisibleChange" :close-on-click-modal="false">
                <el-form :label-position="labelPosition" :model="menuFormChange" label-width="100px" :rules="menuFormChangeRules" ref="menuFormChange" class="clearfix">
                    <el-form-item v-if="menuFormChange.dLevel !== 0 " label="上一级菜单名称:" prop="menuName" style="width: 48%;margin-right: 15px;" class="fl">
                        <el-input type="text" v-model.trim="menuFormChange.menuName" :disabled="true"></el-input>
                    </el-form-item>
                    <el-form-item label="菜单名称:" prop="menuNameNew" style="width: 48%;margin-right: 15px;" class="fl">
                        <el-input type="text" v-model.trim="menuFormChange.menuNameNew" placeholder="请输入菜单名称"></el-input>
                    </el-form-item>
                    <el-form-item label="菜单编码:" prop="menuCode" style="width: 48%;margin-right: 15px;" class="fl">
                        <el-input type="text" v-model.trim="menuFormChange.menuCode"></el-input>
                    </el-form-item>
                    <el-form-item label="菜单图标:" prop="menuIcon" style="width: 48%;margin-right: 15px;" class="fl">
                        <el-input type="text" v-model.trim="menuFormChange.menuIcon" placeholder="请输入icon名称"></el-input>
                    </el-form-item>
                    <el-form-item label="菜单url:" prop="menuUrl" style="width: 48%;margin-right: 15px;" class="fl">
                        <el-input  type="text" v-model.trim="menuFormChange.menuUrl" placeholder="请输入有效的平台路径"></el-input>
                    </el-form-item>
                    <el-form-item label="是否为根节点:" prop="isRoot" style="width: 48%;margin-right: 15px;" class="fl">
                        <el-select v-model.trim="menuFormChange.isRoot" style="width: 100%;">
                            <el-option :label="item.product_type" :value="item.categorya_id" v-for="(item,index) in contractLists" :key="index"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="备注:" prop="memo" style="width: 100%;" class="fl">
                        <el-input type="textarea" v-model.trim="menuFormChange.memo" placeholder="请输入描述信息"></el-input>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button type="success" @click="saveMenu()">保存</el-button>
                    <el-button type="warning" @click.native="dialogMenuVisibleChange=false">取消</el-button>
                </div>
            </el-dialog>
        </el-card>
        <el-card class="box-card box-card-big fr">
            <div slot="header" class="clearfix header">
                <span class="card-header fl">权限信息</span>
                <el-button class="fr" size="mini" type="success" v-if="authorityAuth.handleAddForm" @click="handleAddForm()">新增</el-button>
            </div>
            <el-row>
                <el-col :span="24">
                    <el-table :data="configureInfo" highlight-current-row border style="width: 100%;" 
                        :header-cell-style="{'text-align':'center'}">
                        <el-table-column prop="autName" label="权限名称" width="200" align="center" sortable></el-table-column>
                        <el-table-column prop="menuName" label="模块" width="200" align="center"></el-table-column>
                        <el-table-column label="操作" min-width="250" align="center">
                            <template slot-scope="scope">
                                <el-dropdown  trigger="click">
                                    <el-button type="primary" size="mini">更多操作<i class="el-icon-arrow-down el-icon--right"></i></el-button>
                                    <el-dropdown-menu slot="dropdown">
                                        <el-dropdown-item  v-if="authorityAuth.handleEditForm" @click.native="handleEditForm(scope.$index, scope.row)">修改</el-dropdown-item>
                                        <el-dropdown-item v-if="authorityAuth.handleDelEditForm" @click.native="handleDelEditForm(scope.$index, scope.row)">删除</el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>
                            </template>
                        </el-table-column>
                    </el-table>
                    <!-- dialog对话框 -->
                    <!-- 新增界面 and 修改界面-->
                    <el-dialog :title="textMap[dialogStatus]" :visible.sync="dialogFormVisible" :close-on-click-modal="false" @close="emptyDialogzuhu">
                        <el-form :label-position="labelPosition" :model="editForm" label-width="100px" :rules="editFormRules" ref="editForm">
                            <el-row>
                                <el-form-item label="所属模块:" prop="menuName" style="width: 48%;" class="fl">
                                    <el-input v-model.trim="editForm.menuName" :disabled="true"></el-input>
                                </el-form-item>
                                <el-form-item label="权限名称:" prop="autName" style="width: 48%;" class="fr">
                                    <el-input v-model.trim="editForm.autName" placeholder="请输入权限名称"></el-input>
                                </el-form-item>
                            </el-row>
                            <el-row>
                                <el-form-item label="权限类型:" prop="autType" style="width: 48%;" class="fl">
                                    <el-select v-model.trim="editForm.autType" style="width: 100%;">
                                        <el-option :label="item.product_type" :value="item.categorya_id" v-for="(item,index) in businessLists" :key="index"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-row>
                            <el-form-item label="可访问URL列表:" prop="autUrlMethod">
                                <el-input type="textarea" v-model.trim="editForm.autUrlMethod" placeholder="'url|method',多个路径用回车隔开"></el-input>
                            </el-form-item>
                            <el-form-item label="备注:" prop="memo">
                                <el-input type="textarea" v-model.trim="editForm.memo" placeholder="请输入描述信息"></el-input>
                            </el-form-item>
                        </el-form>
                        <div slot="footer" class="dialog-footer">
                            <el-button v-if="dialogStatus=='create'" type="success" @click="createData">添加</el-button>
                            <el-button v-else type="success" @click="updateData()">保存</el-button>
                            <el-button type="warning" @click.native="dialogFormVisible=false">取消</el-button>
                        </div>
                    </el-dialog>
                </el-col>
            </el-row>
        </el-card>
    </div>
</template>

<script>
    import { menuSelectAuthority,menuRecursive,deletemenu,menuAdd,changeMenu,deleteAuthority,updateByPrimaryKey,selectByPrimaryKey,insertAuthority } from '../../api/api'
    import TreeRender from './components/tree_render.vue';
    import {getPermission} from '../../api/authRequest'

    export default {
        name: 'authorityList',
        data () {
            return {
                //获取上级菜单
                editStatus:{
                    menuId:'',
                    menuName: '极吼吼'
                },
                editEventNodeRules:{
                    menuName: [{ required: true, message: "请输入组织名称", trigger: "blur" }],
                },
                contractLists:[
                    {
                        categorya_id: 0,
                        product_type: "否"
                    },
                    {
                        categorya_id: 1, 
                        product_type: "是"
                    },
                ],
                businessLists:[
                    {
                        categorya_id: 1, 
                        product_type: "系统级权限"
                    },
                    {
                        categorya_id: 0, 
                        product_type: "业务级权限"
                    },
                ],
                defaultMenuId: '',
                labelPosition: 'left',
                theData: [],
                defaultProps: { 
                    children: 'childMenus', 
                    label: 'label' 
                }, 
                /*触发的当前的节点，放到全局，方便调用*/
                triggerCurrenNodeData:{}, /*触发的当前节点*/ 
                triggerCurrenNode:{}, /*新增事件弹窗的输入框数据*/ 
                currentIndex: '',
                configureInfo: [
                    {
                        autName: '',
                        menuName: "",
                        autType: '',
                        autUrlMethod: '',
                        momo:''
                    }
                ],
                //分页
                pages:{
                    total: 0,
                    page: 1,
                    pageSize: 10,
                },
                //新增菜单
                dialogMenuVisible:false,
                menuForm: {
                    childMenus: '',
                    menuName: '',
                    menuNameNew: '',
                    menuCode: '',
                    menuIcon: '',
                    menuUrl: '',
                    isRoot: '是',
                    memo: '',
                    preId: '',
                    dLevel: '',
                    menuId: ''
                },
                menuFormRules: {
                    menuNameNew: [{ required: true, message: "请输入菜单名称", trigger: "blur" }],
                },
                // 修改菜单
                dialogMenuVisibleChange:false,
                menuFormChange: {
                    childMenus: '',
                    menuName: '',
                    menuNameNew: '',
                    menuCode: '',
                    menuIcon: '',
                    menuUrl: '',
                    isRoot: '是',
                    memo: '',
                    preId: '',
                    dLevel: '',
                    menuId: ''
                },
                menuFormChangeRules: {
                    menuNameNew: [{ required: true, message: "请输入菜单名称", trigger: "blur" }],
                },
                //模块菜单
                dialogMenuForm:false,
                dialogMenuStatus:'',
                textMenuMap: {
                    newdata:'新增菜单',
                    update: "新增菜单",
                },
                dialogmenuForm: {
                    menuName: '',
                    menuNameNew: '',
                    menuCode: '',
                    menuIcon: '',
                    menuUrl: '',
                    isRoot: '是',
                    memo: '',
                },
                dialogStatus: "",
                textMap: {
                    update: "修改功能权限",
                    create: "新增权限信息"
                },
                //新增界面数据
                dialogFormVisible:false,
                editForm: {
                    autName: '',
                    menuName: "",
                    autUrlMethod: '',
                    autType: '',
                    momo:''
                },
                editFormRules: {
                    autName: [{ required: true, message: "请输入权限名称", trigger: "submit"}],
                    // menuName: [{ required: true, message: "请输入权限名称", trigger: "submit"}],
                    autType: [{ required: true,message: "请输入权限类型", trigger: "submit"}],
                },
                authorityAuth:{
                    AddMenuForm:false,
                    handleAddForm:false, 
                    handleEditForm:false, 
                    handleDelEditForm:false,
                }
            }
        },
        mounted () {
            this.getMenuList()
            this.configureInfo = []
            this.authorityAuth.AddMenuForm = getPermission('/system/menu/add');
            this.authorityAuth.handleAddForm = getPermission('/system/menu/insertAuthority');
            this.authorityAuth.handleEditForm = getPermission('/system/menu/updateByPrimaryKey');
            this.authorityAuth.handleDelEditForm = getPermission('/system/menu/deleteAuthority');
        },
        methods: {
            //清空dialog
            emptyDialog:function() {
                this.menuForm = {}
                this.dialogMenuVisible = false
            },
            //清空dialog2
            emptyDialogzuhu:function() {
                this.editForm = {}
                this.dialogFormVisible = false
                // alert(1111)
            },
            // 获取列表--------------------------------------------------------------------
            getGoods () {
                const menuId = this.watchEventForm.menuId
                const menuData = {menuId:menuId}
                menuSelectAuthority(menuData).then((res) => {
                    if (res.data.status == 100) {
                        this.configureInfo = res.data.results
                        this.pages.pageSize = res.data.results.pageSize
                        this.pages.page = res.data.results.pageNum
                        this.pages.total = res.data.results.total
                    }
                }).catch((error) => {
                    this.$Message.error(error.message);
                })
            },
            // 获取模块菜单--------------------------------------------------------------------
            getMenuList () {
                menuRecursive().then((res) => {
                    if (res.data.status ==100) {
                        this.theData = res.data.results
                    }
                }).catch((error) => {
                    this.$Message.error(error.message);
                })
            },
            /*渲染函数*/ 
            renderContent(h, { node, data, store }) { 
                let that = this;//指向vue 
                return h(TreeRender,{ 
                    props:{ NODE: node, DATA: data, STORE: store, }, 
                    on:{ 
                        //新增节点
                         Append: ((s,d,n) => that.appendEvent(s,d,n)),
                        //修改节点 
                        Edit: ((s,d,n) => that.EditEvent(s,d,n)),
                        //删除节点
                        Delete: ((s,d,n) => that.removeEvent(s,d,n)),
                        //查看节点
                        WatchInfo: ((s,d,n)=> that.WatchEvent(s,d,n))
                    }
                });
            },
            /*树形控件添加节点，添加弹窗出现*/
            appendEvent(s,d,n) {
                this.dialogMenuVisible = true;
                this.dialogMenuStatus = "update";
                this.triggerCurrenNodeData = d;
                this.triggerCurrenNode = n;
                this.editStatus = Object.assign({}, d);
                this.menuForm.menuName = this.editStatus.menuName
            },
            /*树形控件修改节点，修改弹窗出现*/
            EditEvent(s,d,n) {
                this.dialogMenuVisibleChange = true;
                this.triggerCurrenNodeData = d;
                this.triggerCurrenNode = n;
                this.editStatus = Object.assign({}, d);
                const menuId = this.editStatus.menuId
                const menuData = {menuId:menuId}
                selectByPrimaryKey(menuData).then((res) => {
                  if (res.data.status == 100) {
                        res.data.results.menuNameNew = res.data.results.menuName;
                        this.menuFormChange = res.data.results;
                        if (res.data.results.preId !== null) {
                            const menuId = res.data.results.preId
                            const menuData = {menuId:menuId}
                            selectByPrimaryKey(menuData).then(res => {
                                if (res.status===200) {
                                    this.menuFormChange.menuName = res.data.results.menuName
                                }
                            }).catch((error) =>{
                                this.$Message.error(error.message);
                            })
                        }
                    }
                }).catch((error) => {
                    this.$Message.error(error.message);
                })
            },
            /*树形控件删除节点*/
            removeEvent(s,d,n) {
                this.triggerCurrenNodeData = d;
                this.triggerCurrenNode = n;
                this.addEventForm = Object.assign({}, d);
                this.$confirm('确定要删除该节点吗？', '温馨提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let para = { menuId: this.addEventForm.menuId };
                    deletemenu(para).then(res => {
                        if (res.data.status == 100) {
                            this.$message({
                                message: res.data.message,
                                type: "success"
                            });
                            this.getMenuList()
                        }else{
                            this.$message({
                                message: res.data.message,
                                type: "error"
                            });
                        }
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            /*树形控件查看节点*/
            WatchEvent(s,d,n) {
                this.triggerCurrenNodeData = d;
                this.triggerCurrenNode = n;
                this.watchEventForm = Object.assign({}, d);
                //获取权限信息
                this.getGoods()
            },
            /*节点新增，新增树形菜单事件分类弹窗，取消按钮*/
            addEventFormCancleBtn(){
                this.addEventdialogVisible = false;
            },
            //新增一级模块菜单
            AddMenuForm() {
                this.dialogMenuVisible = true
                this.dialogMenuStatus = "newdata";
            },
            //新增一级模块菜单
            FirstLevelMenu(formname){
                this.$refs[formname].validate((valid) => {
                    if (valid) {
                        let para={
                            menuName: this.menuForm.menuNameNew,
                            menuCode: this.menuForm.menuCode,
                            menuIcon: this.menuForm.menuIcon,
                            menuUrl: this.menuForm.menuUrl,
                            memo: this.menuForm.memo,
                        }
                        menuAdd(para).then(res => {
                            if (res.data.status == 100) {
                                this.$message({
                                    message: res.data.message,
                                    type: "success"
                                });
                                /*关闭弹窗，重置输入框*/
                                this.dialogMenuVisible = false;
                                this.$refs[formname].resetFields();
                                /*刷新树形菜单*/
                                this.getMenuList();
                            }else{
                                this.$message({
                                    message: res.data.message,
                                    type: "error"
                                });
                            }
                        }).catch((error) =>{
                            this.$Message.error(error.message);
                        })
                    } else {
                        console.log('验证未通过');
                        return false;
                    }
                });
            },
            //新增二级菜单
            updateMenu:function(formname) {
                this.$refs[formname].validate((valid) => {
                    if (valid) {
                        let para={
                            menuName: this.menuForm.menuNameNew,
                            menuCode: this.menuForm.menuCode,
                            menuIcon: this.menuForm.menuIcon,
                            menuUrl: this.menuForm.menuUrl,
                            memo: this.menuForm.memo,
                            preId: this.triggerCurrenNodeData.menuId,
                            dLevel: this.triggerCurrenNodeData.level ,//当前节点层级
                            memo: this.menuForm.memo,
                        }
                        menuAdd(para).then(res => {
                            if (res.data.status==100) {
                                this.$message({
                                    message: res.data.message,
                                    type: "success"
                                });
                                /*关闭弹窗，重置输入框*/
                                this.dialogMenuVisible = false;
                                this.$refs[formname].resetFields();
                                /*刷新*/
                                this.getMenuList();
                            }else{
                                this.$message({
                                    message: res.data.message,
                                    type: "error"
                                });
                            }
                        }).catch((error) =>{
                            this.$Message.error(error.message);
                        })
                    } else {
                        console.log('验证未通过');
                        return false;
                    }
                });
            },
            //节点修改，修改树形菜单事件分类弹窗，保存按钮
            saveMenu:function() {
                this.$confirm("确认修改该菜单?", "提示", {
                    type: "warning"
                }).then(() => {
                    let para = {
                        menuName:this.menuFormChange.menuNameNew,
                        dLevel:this.menuFormChange.dLevel,
                        isRoot:this.menuFormChange.isRoot,
                        menuId:this.menuFormChange.menuId,
                        menuCode:this.menuFormChange.menuCode,
                        menuIcon:this.menuFormChange.menuIcon,
                        menuUrl:this.menuFormChange.menuUrl,
                        memo:this.menuFormChange.memo
                    };
                    changeMenu(para).then(res => {
                        if (res.data.status ==100) {
                            this.$message({
                                message: res.data.message,
                                type: "success"
                            });
                            this.dialogMenuVisibleChange = false
                            this.getMenuList()
                        }else{
                            this.$message({
                                message: res.data.message,
                                type: "error"
                            });
                        }
                    }).catch((error) => {
                        this.$Message.error(error.message);
                    })
                }).catch((error) => {
                    this.$Message.error(error.message);
                })
            },
            //新增用户
            handleAddForm() {
                if (this.watchEventForm !==undefined && this.watchEventForm.childMenus==null) {
                    this.dialogFormVisible = true
                    this.dialogStatus = "create";
                    this.editForm.menuName = this.watchEventForm.menuName
                    this.editForm.menuId = this.watchEventForm.menuId
                }else{
                    this.$message({
                        message: "请先选择对应的模块菜单或二级菜单",
                        type: "waring"
                    });
                }
            },
            //新增
            createData: function() {
                this.dialogStatus = "create";
                this.$refs.editForm.validate(valid => {
                    if (valid) {
                        this.$confirm("确认提交吗？", "提示", {}).then(() => {
                            let para = {
                                menuId:this.editForm.menuId,
                                autName:this.editForm.autName,
                                autType:this.editForm.autType,
                                autUrlMethod:this.editForm.autUrlMethod,
                                memo:this.editForm.memo,
                            }
                            insertAuthority(para).then(res => {
                                if (res.data.status == 100) {
                                    this.$message({
                                        message: res.data.message,
                                        type: "success"
                                    });
                                    this.$refs["editForm"].resetFields();
                                    this.dialogFormVisible = false;
                                    this.getGoods()
                                }else{
                                    this.$message({
                                        message: res.data.message,
                                        type: "error"
                                    });
                                }
                            }).catch((error) => {
                                this.$Message.error(error.message);
                            })
                        }).catch(e => {
                            // 打印一下错误
                            console.log(e);
                        });
                    }
                });
            },
            //显示编辑界面
            handleEditForm: function(index, row) {
                this.dialogFormVisible = true;
                this.dialogStatus = "update";
                this.editForm = Object.assign({}, row);
            },
            //确认修改
            updateData:function() {
                this.dialogStatus = "create";
                this.$refs.editForm.validate(valid => {
                    if (valid) {
                        this.$confirm("确认提交吗？", "提示", {}).then(() => {
                            let para = {
                                autId:this.editForm.autId,
                                autName:this.editForm.autName,
                                autType:this.editForm.autType,
                                autUrlMethod:this.editForm.autUrlMethod,
                                memo:this.editForm.memo,
                            }
                            updateByPrimaryKey(para).then(res => {
                                if (res.data.status == 100) {
                                    this.$message({
                                        message: res.data.message,
                                        type: "success"
                                    });
                                    this.$refs["editForm"].resetFields();
                                    this.dialogFormVisible = false;
                                    this.getGoods()
                                }else{
                                    this.$message({
                                        message: res.data.message,
                                        type: "error"
                                    });
                                }
                            }).catch((error) => {
                                this.$Message.error(error.message);
                            })
                        }).catch(e => {
                            // 打印一下错误
                            console.log(e);
                        });
                    }
                });
            },
            handleDelEditForm:function (index,row) {
                this.$confirm("确认删除该记录吗?", "提示", {
                    type: "warning"
                }).then(() => {
                    let para = { autId: row.autId };
                    deleteAuthority(para).then(res => {
                        if (res.data.status == 100) {
                            this.$message({
                                message: res.data.message,
                                type: "success"
                            });
                            this.getGoods()
                        }else{
                            this.$message({
                                message: res.data.message,
                                type: "error"
                            });
                        }
                    });
                }).catch(() => {});
            },
            handleSizeChange(val) {
                this.pages.pageSize = val
                this.getGoods()
            },
            handleCurrentChange(Page) {
                this.pages.page = Page
                this.getGoods()
            },
        }
    }
</script>
 
<style scoped>
    .authorityList .box-card{margin-bottom: 20px;border-radius: 0px;width: 35%;}
    .authorityList .box-card .header{background-color: #f5f5f5}
    .authorityList .box-card .card-header{font-size: 14px;}
    .authorityList .box-card-big{width: 60%;margin-left: 20px;}
    @import '../../assets/css/logistics.css';
    .icon {display: inline-block;width: 15px;height: 15px;background-repeat: no-repeat;vertical-align: -2px;}
    .folder {background-image: url(../../assets/images/folder.png);}
    .folder-open {background-image: url(../../assets/images/folder-open.png);}
    .file-text {background-image: url(../../assets/images/file-text.png);}
    .loading {background-image: url(../../assets/images/loading.gif);background-size: 15px;}
    .menuLi{cursor: pointer;}
    .menuLi > span{display: none;}
    .menuLi > span i{border:1px solid transparent;margin: 0 2px;}
    .menuLi:hover > span{display: inline-block;}
    .menuLi > span i:hover{border:1px solid #999;}
    .toolbar{margin-top: 20px;}
</style>


// WEBPACK FOOTER //
// functionAuthorityList.vue?4dec03a1